import React, { Component } from "react";
import { NormalButton } from "component/common";
//import "./style.scss";
import { Navigation } from "react-minimal-side-navigation";
import { CgMenuLeft } from "react-icons/cg";
import { withTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { Navbar } from "../backend";
import { AiOutlineRight, AiOutlineDown } from "react-icons/ai";
export class InventoryClass extends Component {
  state = {
    currentMenu: "/",
    ismenu: false,
  };

  handleMenuChange = (itemId) => {
    this.setState({
      currentMenu: itemId,
    });
  };

  handlemenuoption = () => {
    this.setState({
      ismenu: !this.state.ismenu,
    });
  };
  render() {
    let { currentMenu, ismenu } = this.state;
    const Heading = [
      {
        // image: btc,
        title: "Stock Usage Memo",
        link: "/admin/backend/",
      },
      {
        // image: btc,
        title: "Stock Movement",
        link: "/admin/backend/itemmaster",
      },
    ];
    let { t } = this.props;
    return (
      <div className="col-md-12 ">
        <div className="container-fluid bg-white px-md-5 my-3">
          <div className="py-5">
            <p className="fs-16">
              <span className="font-weight-bold px-1 ml-4 ">HOME</span>/BACKEND
            </p>
            <h2 className="my-4 ml-4 main-title">Back End</h2>
            <p className="font-weight-normal fs-16 ml-4">
              See full list of your backend reports here
            </p>
            <div className="row my-3 d-flex ">
              <div className="col-md-3 font-weight-bold">
                <Navbar />
              </div>
            </div>
            <div className="card-head ">
              {Heading.map((item, index) => {
                const isActive = this.state.activeIndex === index;
                const hasChildren = item.children && item.children.length > 0;

                return (
                  // <div className="col-lg-6 ">
                  <div className="col-md-6 col-sm-12 " key={index}>
                    <div className="card ">
                      <div
                        className="card-body row d-flex justify-content-between align-items-center"
                        // onClick={() => this.toggleDropdown(index)}
                      >
                        <div className="col-md-6 ">
                          <p className="card-title">{item.title}</p>
                          {/* <p>{item.time}</p> */}
                        </div>

                        <div className="col-md-6 col-sm-2 mt-2  text-center">
                          {hasChildren && isActive ? (
                            <AiOutlineDown />
                          ) : hasChildren && !isActive ? (
                            <AiOutlineRight />
                          ) : (
                            <NormalButton
                              backend={true}
                              label={"View"}
                              // onClick={() => this.handleChange(item.link)}
                            />
                          )}
                        </div>
                      </div>
                      {isActive && (
                        <div className=" col-md-12 mb-2">
                          {console.log(item.children, "itemChild")}
                          {item.children &&
                            item.children.map((child, index) => (
                              <div className="col-md-12 mt-2 d-flex justify-content-between align-items-center">
                                <div className="col-md-6">
                                  <p className="child-title">{child.title}</p>
                                </div>
                                <div className="col-md-6">
                                  <NormalButton
                                    backend_child={true}
                                    label={"View"}
                                    onClick={() =>
                                      this.handleChange(child.link)
                                    }
                                  />
                                </div>
                                {/* <p>{item.time}</p> */}
                              </div>
                            ))}
                        </div>
                      )}
                    </div>
                  </div>
                  // </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>

      // <div className="container-fluid itemmaster-container">
      //   <div className="row mb-4">
      //     <div className="col-md-4 col-lg-2 mb-2">
      //       <Link to="/admin/backend/">
      //         <NormalButton
      //           normal={true}
      //           className="col-12 fs-15 float-right"
      //           label={t("Master Data")}
      //         />
      //       </Link>
      //     </div>
      //     <div className="col-md-4 col-lg-2 mb-2">
      //       <Link to="/admin/backend/Inventory">
      //         <NormalButton
      //           normal={true}
      //           className="col-12 fs-15 float-right"
      //           label={t("Inventory")}
      //         />
      //       </Link>
      //     </div>
      //   </div>
      //   <div className="row">
      //     <div className={ismenu == true ? "col-md-2 mt-5" : "mt-5"}>
      //       <div className="d-flex">
      //         {ismenu == true ? (
      //           <Navigation
      //             activeItemId="/"
      //             onSelect={({ itemId }) => this.handleMenuChange(itemId)}
      //             items={[
      //               {
      //                 title: t("Stock Usage Memo"),
      //                 itemId: "/",
      //               },
      //               {
      //                 title: t("Stock Movement"),
      //                 itemId: "/stockmovement",
      //               },
      //             ]}
      //           />
      //         ) : null}
      //       </div>
      //     </div>
      //     <div className={ismenu == true ? "col-md-10 mt-5" : "col-md-12 mt-5"}>
      //       <div className="d-flex">
      //         <CgMenuLeft size={30} onClick={() => this.handlemenuoption()} />
      //         {currentMenu == "/" ? (
      //           <div>Stock Usage Memo</div>
      //         ) : (
      //           <div>Loading..</div>
      //         )}
      //       </div>
      //     </div>
      //   </div>
      // </div>
    );
  }
}

export const Inventory = withTranslation()(InventoryClass);
